// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x9-1";
export var printerIcon = "_x9-0";